/* eslint-disable func-names */
import EDC from './globals';
import Button from './button';

/**
 *
 */
EDC.UI.MenuButton = function (scene, x, y) {
  Button.call(this, scene, x, y);
  this.lightSprite = null;
  return this;
};
/**
 *
 */
EDC.UI.MenuButton.prototype = Object.create(Button.prototype);
EDC.UI.MenuButton.prototype.constructor = EDC.UI.MenuButton;
/**
 *
 */
EDC.UI.MenuButton.prototype.create = function (normal, hover, down = null, disabled = null) {
  Button.prototype.create.call(this, normal, hover, down, disabled);
  this.lightSprite = this.scene.add.sprite(0, 0, 'menu-light');
  this.lightSprite.setAlpha(0);
  this.container.add(this.lightSprite);

  return this;
};
/**
 *
 */
EDC.UI.MenuButton.prototype.onOver = function () {
  this.scene.tweens.add({
    targets: [this.sprites[this.states.BTN_STATE_HOVER], this.lightSprite],
    alpha: 1,
    duration: 100,
    ease: 'Linear',
  });
  if (this.overCallback) {
    this.overCallback(this);
  }
};
/**
 *
 */
EDC.UI.MenuButton.prototype.onOut = function () {
  if (this.sprites[this.states.BTN_STATE_DOWN]) {
    this.sprites[this.states.BTN_STATE_DOWN].setAlpha(0);
  }
  this.scene.tweens.add({
    targets: [this.sprites[this.states.BTN_STATE_HOVER], this.lightSprite],
    alpha: 0,
    duration: 100,
    ease: 'Linear',
  });
};

export default EDC.UI.MenuButton;
